import CollectionContainer from '../containers/Collection';
import { initVisualFilters, initTabbableVisualFilters } from '../modules/VisualFilters';
import { pushToDataLayer, quantumMetricEvent } from '../services/analytics.service';
import { generateMediaElement } from '../services/media-content.service';
import { getPersonalizationCampaigns, reportEngagement } from '../services/personalization.service';
import { capitalizeFirstLetter } from '../helpers/transformations';
import { showModal } from '../services/dialog.service';
import { getElementOrParentByClassName, waitForElements } from '../helpers/utils';
import { getAlternateTemplate } from '../services/template.service';
import { refreshWishlistIcons } from '../services/wishlist.service';
import '../../styles/templates/_collection-v2.scss';
import { getSocialProof } from '../services/recommendation.service';
import { getLiquidEngine } from '../services/liquid.service';
import productBadgeTemplate from '../../snippets/product-badge.liquid';
import LazyImages from '../modules/LazyImages';
import { scrollTo } from '../helpers/scrollPage';

const QM_PLP_FILTER_RESULT_COUNT = 260;
const typeToFunction = {
  "editorial-card": generateMediaElement
};

let socialProofConfig;
let decisionId;
const SOCIAL_PROOF_SHOWN_CLASS = "js-social-proof-shown";

class CollectionV2Template extends CollectionContainer {
  constructor() {
    super();
    super.init();
  }

  init() {
    window.addEventListener("filter.afterFilter", () => {
      quantumMetricEvent(QM_PLP_FILTER_RESULT_COUNT, 0, window.boostPFS?.filter?.data?.total_product);
    });
    window.addEventListener("filter.afterInit", () => {
      if (window.UNTUCKitConfig?.thirdPartyToggles?.boostAutoSelectLoadPrevious) {
        const loadPrevBtn = document.querySelector(".js-boost-pfs-filter-btn-load-previous-page");
        if (loadPrevBtn && window.Globals?.queryParams?.page > 1) {
          setTimeout(() => {
            const observer = new IntersectionObserver((entries, observer) => {
              const entry = entries[0];
              if (entry.isIntersecting) {
                entry.target.click();
                observer.disconnect();
              }
            }, {
              threshold: [0.5]
            });
            observer.observe(loadPrevBtn);
          }, 1000); // TODO: better way to provide some time for boost to scroll down the page?
        }
      }
      // attempt at "anchoring" to a specific editorial card
      const editorial = new URLSearchParams(location.search).get('editorial');
      if (editorial) {
        waitForElements(`#${editorial}`).then((els) => {
          scrollTo(els[0]);
        });
      }
    });
    window.addEventListener("filter.afterRender", async () => {
      // accessibility fix for boost checkboxes
      document.querySelectorAll('.boost-pfs-check-box[aria-labelledby]').forEach(el => {
        el.setAttribute('aria-label', el.getAttribute('aria-labelledby'));
        el.removeAttribute('aria-labelledby');
      });
      if (!socialProofConfig && window.UNTUCKitConfig.dySocialProofApiSelectorName) {
        const socialProofResults = await getPersonalizationCampaigns({ apiSelectorNames: [window.UNTUCKitConfig.dySocialProofApiSelectorName]});
        const choice = socialProofResults?.choices?.[0];
        if (choice) {
          decisionId = choice.decisionId;
          socialProofConfig = choice.variations.length ? choice.variations[0].payload.data : null; // note: variations will be empty if no targeting applies to the customer
        }
      }
      if (socialProofConfig) {
        const productItems = Array.from(document.querySelectorAll('.boost-pfs-filter-product-item:not(.media-content__container)'));
        const skus = productItems.map(item => item.dataset.dySku).filter(sku => !!sku); // sku might be missing for "coming soon" products, for example
        console.log("social proof skus", skus);
        if (skus?.length) {
          try {
            const socialProofs = (await getSocialProof(skus, socialProofConfig.timespan, socialProofConfig.interaction));
            console.log("socialProofs", socialProofs);
            const trendingNowHtml = getLiquidEngine().parseAndRenderSync(productBadgeTemplate, {
              label_text: socialProofConfig.label,
              label_style_class: "social-proof",
              icon_url: socialProofConfig.iconUrl
            });
            const template = document.createElement('template');
            template.innerHTML = trendingNowHtml;
            const el = template.content.firstElementChild;
            productItems.forEach(i => {
              const socialProof = socialProofs[i.dataset.dySku];
              const socialProofHits = socialProof?.productInterest?.[socialProofConfig.interaction]?.[socialProofConfig.timespan];
              if (socialProofHits !== undefined && socialProofHits > +socialProofConfig.threshold) {
                i.classList.add(SOCIAL_PROOF_SHOWN_CLASS);
                const badgesContainer = i.querySelector('.product-badge-container');
                const existingSocialProofBadge = badgesContainer.querySelector('.product-badge-v2__container--social-proof');
                if (badgesContainer && !existingSocialProofBadge) {
                  badgesContainer.append(el.cloneNode(true));
                }
              }
            });
          } catch (err) { // eslint-disable-line no-unused-vars
            //
          }
        }
      }
    });
    window.addEventListener("filter.addEditorialContent", async () => {
      await addEditorialContent(window.UTK_content);
      repositionEditorialElements();
    });
    if (window.UTK_content) {
      if (window.UTK_content.visualFilters) {
        initVisualFilters();
      }
      if (window.UTK_content.tabbableVisualFilters) {
        initTabbableVisualFilters();
      }
    }
    $('.collection-v2').on("click", ".collection-v2-side-nav__link", (e) => {
      const container = e.target.classList.contains("collection-v2-side-nav") ? e.target : e.target.closest(".collection-v2-side-nav");
      if (container) {
        const collectionTitleEl = document.querySelector(".collection-v2__collection-title");
        const titleEl = container.querySelector(".collection-v2-side-nav__title");
        const urlEl = container.querySelector("a");
        const clicked = `${collectionTitleEl ? collectionTitleEl.textContent: ""} > ${titleEl ? titleEl.textContent : ""} > ${urlEl ? urlEl.textContent : ""}`;
        const navPosition = 'top'; // position based off of old side nav position
        pushToDataLayer({
          event: 'Nav Click',
          itemClicked: clicked,
          navPosition: navPosition
        });
      }
    });
    document.addEventListener("click", (e) => {
      const target = e.target;
      const waitlistTrigger = getElementOrParentByClassName(target, "js-trigger-bis");
      if (waitlistTrigger) {
        const waitlistFormEl = document.createElement('waitlist-form');
        waitlistFormEl.setAttribute('variantId', waitlistTrigger.dataset.variantId);
        waitlistFormEl.setAttribute('productId', waitlistTrigger.dataset.productId);
        waitlistFormEl.setAttribute('title', "We’ll notify you as soon as this item is available.");
        showModal([waitlistFormEl]);
      }
    });
    if (window.UNTUCKitConfig.dySocialProofApiSelectorName) {
      window.addEventListener("click", reportSocialProofEngagement);
    }
  }
}

$(() => {
  new CollectionV2Template();
});

document.addEventListener("click", async (e) => {
  const target = e.target;
  if (target.classList.contains("js-product-option") && !target.classList.contains("product-option--selected")) {
    e.stopPropagation();
    const initialColorSwatches = target.closest(".product-grid-item-v2__product-swatch-container");
    if (initialColorSwatches) {
      initialColorSwatches.querySelectorAll(".js-product-option").forEach(c => c.classList.remove("product-option--selected"));
      target.classList.add("product-option--selected");
      const initialScrollLeft = initialColorSwatches.scrollLeft;
      const handle = target.dataset.productHandle;
      const productCardHTML = await getAlternateTemplate(`/collections/${window.collectionHandle}/products/${handle}`, 'plp-card');
      const productCardEl = target.closest(".boost-pfs-filter-product-item");
      productCardEl.innerHTML = productCardHTML;
      const newColorSwatches = productCardEl.querySelector('.product-grid-item-v2__product-swatch-container');
      newColorSwatches.replaceWith(initialColorSwatches);
      initialColorSwatches.scrollTo(initialScrollLeft, 0);
      if (typeof window.boostSwapImage === 'function') {
        window.boostSwapImage();
      }
      refreshWishlistIcons('.boost-pfs-filter-products');
    }
  }
});

let currentDeviceType = getDeviceType();

window.addEventListener("resize", function() {
  const newDeviceType = getDeviceType();
  if (currentDeviceType !== newDeviceType) {
    currentDeviceType = newDeviceType;
    repositionEditorialElements();
  }
});

async function addEditorialContent(config) {
  console.log("addEditorialContent");
  const gridContainer = getGridContainer();
  const hasExistingContent = gridContainer.querySelectorAll(".editorial-content").length > 0;
  if (config && !hasExistingContent) {
    console.log("no existing editorial content; adding");
    if (config.defaultEditorialContentSetup && config.defaultEditorialContentSetup.slots) {
      let personalizationResults = null;
      if (config.defaultApiSelectorNames && config.defaultApiSelectorNames.length) {
        personalizationResults = await getPersonalizationCampaigns({ apiSelectorNames: config.defaultApiSelectorNames })
      }
      config.defaultEditorialContentSetup.slots.forEach(function(s) {
        const card = s.personalization && personalizationResults ? determineCardByPersonalization(s, personalizationResults) : s.defaultCard;
        if (card) {
          if (skipEditorialCard(card, s.hideWhenFilterApplied)) {
            console.log("skipping editorial card", card);
            return;
          }
          let cardEl;
          const cardElFunc = typeToFunction[card._type];
          if (cardElFunc) {
            const overrides = {
              imageSrcset: [375, 390, 414, 428, 768, 800, 1024, 1280, 1440],
              sizes: "33vw, 50vw, (max-width: 1440px) 100vw, 1440px"
            };
            cardEl = cardElFunc(card, overrides);
          } else {
            throw new Error("card el generator not defined for type");
          }
          cardEl.classList.add("card-" + card.size, "editorial-content", "boost-pfs-filter-product-item", "boost-pfs-filter-product-item-grid", "hidden");
          cardEl.dataset.size = card.size;
          ["mobile", "tablet", "desktop"].forEach((device) => {
            if (s[`display${capitalizeFirstLetter(device)}`]) {
              cardEl.dataset[`${device}Location`] = s[`${device}Location`];
              cardEl.dataset[`${device}Row`] = s[`${device}Row`];
              cardEl.dataset[`${device}Column`] = s[`${device}Column`];
            }
          });
          gridContainer.append(cardEl);
        } else {
          // note: cards may be intentionally left out (e.g. hiding specific cards for certain segments)
          console.warn("no card defined for slot", s);
        }
      });
    }
  }
}

function getGridContainer() {
  return document.querySelector(".boost-pfs-filter-products")
}

function determineCardByPersonalization(slot, personalization) {
  let card = slot.defaultCard;
  if (personalization) {
    const decision = personalization.choices.find((c) => c.name.toLowerCase() === slot.personalization.apiSelectorName.toLowerCase());
    if (decision && decision.variations[0]) {
      const payloadData = decision.variations[0].payload.data;
      if (payloadData) {
        const id = payloadData.id;
        const variation = slot.personalization.variations.find(v => v.variationId.toLowerCase() === id.toLowerCase());
        if (variation) {
          const behavior = variation.variationBehavior;
          if (behavior === "hide") {
            card = null;
          } else if (behavior === "replace") {
            card = variation.replacement;
          }
        } else {
          console.error(`unable to determine card for variationId ${id}`);
        }
      } else {
        console.log("user served control");
      }
      if (card) {
        card = { ...card, decisionId: decision.decisionId };
      }
    }
  }
  return card;
}

/**
 * determines if a card should be skipped.
 * (e.g. a card that applies a filter shouldn't show if that filter is already applied, etc)
 *
 * @param {*} card
 * @param {boolean} hideWhenFilterApplied
 * @returns {boolean}
 */
function skipEditorialCard(card, hideWhenFilterApplied) {
  let skipCard = false;
  const cardUrl = card.url;
  const isFilteredPage = location.href.includes("pf_");
  if (isFilteredPage && hideWhenFilterApplied) {
    skipCard = true;
  } else if (cardUrl) {
    const isProductCard = cardUrl.includes("/products/");
    const isSamePage = cardUrl.includes(location.pathname);
    if (isProductCard && isFilteredPage) {
      skipCard = true;
    } else if (isSamePage) {
      const cardQueryParams = new URLSearchParams(cardUrl.substring(cardUrl.indexOf("?")));
      const pageQueryParams = new URLSearchParams(location.search);
      const allCardQueryParamsApplied = !Array.from(cardQueryParams.entries()).find(([key, val]) => {
        return pageQueryParams.get(key) !== val;
      });
      if (allCardQueryParamsApplied) {
        skipCard = true;
      }
    }
  }
  return skipCard;
}

function reportSocialProofEngagement(e) {
  const target = e.target;
  if (getElementOrParentByClassName(target, SOCIAL_PROOF_SHOWN_CLASS)) {
    reportEngagement([{type: "CLICK", decisionId }]);
  }
}

/**
 * repositons editorial content within the product list
 * so that they sit in the correct locations (for keyboard users)
 */
function repositionEditorialElements() {
  let previousPageSlots =  ((window.Globals.queryParams.page - 1) * window.Globals.queryParams.limit);
  console.log("repositionEditorialElements");
  const content = Array.from(document.querySelectorAll(".editorial-content"));
  if (content) {
    const gridContainer = getGridContainer();
    const device = getDeviceType();
    let overallDummySlots = 0;
    const numCols = isMobileTablet() ? 2 : 3;
    content
    .sort((a,b) => editorialSort(a, b, device))
    .forEach((c) => {
      const location = c.dataset[device + "Location"];
      if (!location) {
        c.classList.add("hidden");
      } else {
        let added = false;
        if (location === "first" && isFirstPage()) {
          gridContainer.prepend(c);
          added = true;
        } else if (location === "last" && isLastPage())  {
          gridContainer.append(c);
          added = true;
        } else {
          const previousPageFullRows = Math.floor(previousPageSlots / numCols);
          const row = c.dataset[device + "Row"] - previousPageFullRows;
          const col = c.dataset[device + "Column"];
          const position = (+row - 1) * numCols + +col - overallDummySlots;
          // position might be negative if user is on page > 1
          if (position > 0) {
            const referenceNode = gridContainer.children[position - 1];
            if (referenceNode) {
              gridContainer.insertBefore(c, referenceNode);
              added = true;
            } else {
              const payload = { text: c.textContent, row: row, col: col };
              console.warn("Unable to set card; not enough products in grid.", payload);
            }
          } else {
            previousPageSlots += getNumCardSlots(c);
          }
        }
        if (added) {
          c.classList.remove("hidden");
          const dummySlots = getNumCardSlots(c) - 1;
          overallDummySlots += dummySlots;
        }
      }
    });
  }
  LazyImages.update();
}

function getNumCardSlots(cardEl) {
  const size = cardEl.dataset.size; // e.g. 2x1
  let cols = +size[0];
  if (isMobileTablet() && cols === 3) {
    cols = 2;
  }
  const rows = +size[2];
  return cols * rows;
}

function editorialSort(a, b, device) {
  const aLocation = a.dataset[device + "Location"];
  const aRow = +a.dataset[device + "Row"];
  const aColumn = +a.dataset[device + "Column"];
  const bLocation = b.dataset[device + "Location"];
  const bRow = +b.dataset[device + "Row"];
  const bColumn = +b.dataset[device + "Column"];
  // location will be NaN if not intended to be displayed on device
  if (!aLocation && !bLocation) {
    return 0;
  } else if (!aLocation) {
    return 1;
  } else if (!bLocation) {
    return -1;
  } else if (aLocation === "first" || bLocation === "last") {
    return -1;
  } else if (bLocation === "first" || aLocation === "last") {
    return 1;
  } else {
    if (aRow < bRow) {
      return -1;
    } else if (bRow < aRow) {
      return 1;
    } else {
      return aColumn < bColumn ? -1 : bColumn < aColumn ? 1 : 0;
    }
  }
}

/**
 * gets device type by window width
 * mimics getDeviceType from constants/devices.js
 * @returns {string}
 */
function getDeviceType() {
  return window.innerWidth < 768 ? "mobile" : window.innerWidth < 1024 ? "tablet" : "desktop";
}

/**
 * mobile and tablet are intended to be treated the same in most instances
 * mimics isBelowDesktop from constants/devices.js
 * @returns {boolean}
 */
function isMobileTablet() {
  return ["mobile", "tablet"].includes(getDeviceType());
}

function isFirstPage() {
  return window.Globals.queryParams.page === 1;
}

function isLastPage() {
  return Math.ceil(window.Globals.collectionCount / window.Globals.queryParams.limit) === window.Globals.queryParams.page;
}